<template>
  <div class="statements w3-border">
    <div class="w3-card" v-for="(statement) in comment.meta.statements">
      <p>
      <statement-view v-bind:statement="statement" v-bind:convo="convo" v-bind:buttonType="'react'" />
      </p>
    </div>
  </div>
</template>

<script>
  import ConvoCommentStatements from "./ConvoCommentStatements.ts";

  export default ConvoCommentStatements;
</script>
